import ko from 'knockout';
import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import config from '@bingads-webui-component-legacy/config/index';

const s$DsaTarget = window.globalLegacySchema.get('DsaTarget');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class ViewModel {
  constructor(options = {}) {
    const permissions = config.get('Permissions');

    this.urlEqualsEnabled = permissions && permissions.dynamic && permissions.dynamic.DSAUrlEquals;
    this.keyToItemMapping = {};
    this.hasChanges = true;
    this.adGroupBid = ko.observable(options.defaultBid);
    this.errors = ko.observableArray([]);
    this.items = ko.observableArray([]);
    this.items.subscribe(() => {
      this.hasChanges = true;
    }, this);
    this.logActivity = (message) => {
      if (options.activityLogger) {
        options.activityLogger.signal(message, 'ad target selection');
      }
    };

    this.add = (item) => {
      let dsaTarget = this.generateDSATarget(item);

      if (dsaTarget != null) {
        this.items.push(dsaTarget);
        this.logActivity(`ad target add: ${item.type}`);
      }
    };

    this.generateDSATarget = (item) => {
      const conditionsWithOperator = [];
      const conditionsWithoutOperator = [];
      const conditionsWithoutDisplayValue = [];

      _.each(item.conditions, (condition) => {
        const conditionWithOperator = {
          Operand: ko.unwrap(condition.Operand),
          Operator: ko.unwrap(condition.Operator),
          ArgumentOperand: ko.unwrap(condition.ArgumentOperand),
          DisplayOperand: ko.unwrap(condition.DisplayOperand),
          DisplayOperator: ko.unwrap(condition.DisplayOperator),
        };

        if (conditionWithOperator.ArgumentOperand && item.shouldCheckArgumentOperandFormat) {
          conditionWithOperator.ArgumentOperand = this.checkArgumentOperandFormat(conditionWithOperator.ArgumentOperand);
        }
        conditionsWithOperator.push(conditionWithOperator);
        conditionsWithoutDisplayValue.push(_.pick(conditionWithOperator, 'Operand', 'Operator', 'ArgumentOperand'));
        conditionsWithoutOperator.push(_.pick(conditionWithOperator, 'Operand', 'ArgumentOperand'));
      });

      const key = this.urlEqualsEnabled ? JSON.stringify(conditionsWithoutDisplayValue) : JSON.stringify(conditionsWithoutOperator);

      if (!this.keyToItemMapping[key]) {
        const dsaTarget = {};

        koSchema.properties(dsaTarget, s$DsaTarget, _.keys(s$DsaTarget.properties));
        dsaTarget.conditions = item.conditions;

        if (item.type === 'specificpage' || item.type === 'exacturls') {
          dsaTarget.serializedConditions = JSON.stringify(conditionsWithOperator);
        } else {
          dsaTarget.serializedConditions = '';
        }
        dsaTarget.type = item.type;
        dsaTarget.Bid(item.bid);//eslint-disable-line

        dsaTarget.Bid.subscribe(() => {
          this.hasChanges = true;
          this.logActivity('ad target bid changed');
        }, this);
        dsaTarget.Criterion ({//eslint-disable-line
          Type: 'Webpage',
          WebPage: {
            Parameter: {
              Conditions: this.urlEqualsEnabled ? conditionsWithoutDisplayValue : conditionsWithoutOperator,
            },
          }});
        dsaTarget.hasErrors = false;

        this.keyToItemMapping[key] = dsaTarget;
        dsaTarget.key = key;

        return  dsaTarget;
      }
      return null;
    };

    // knockout model has performance issue when populating value to observableArray one by one.
    // This function is designed to solve performance issue by only notify ui once all elements have been added.
    this.addBatch = (items) => {

      let underlyingArray = this.items();

      _.each(items, (item) => {
        let dsaTarget = this.generateDSATarget(item);

        if (dsaTarget != null) {
          underlyingArray.push(dsaTarget);
        }
      });
      this.items.valueHasMutated();   //notifies ui once all elements have been added
    };

    this.remove = (item) => {
      this.items.remove(item);
      delete this.keyToItemMapping[item.key];
      this.logActivity(`ad target removed: ${item.type}`);
    };

    this.update = (items, removedItems) => {
      _.each(removedItems, (item) => {
        delete this.keyToItemMapping[item.key];
      });

      this.items(items);
    };

    this.resetBids = () => {
      _.each(this.items(), (item) => {
        item.Bid(null);//eslint-disable-line
        item.Bid._string.notifySubscribers();
      });
      this.logActivity('clear all target bid');
    };
    this.clear = () => {
      this.items([]);
      this.keyToItemMapping = {};
      this.logActivity('remove all target');
    };
    this.isListEmpty = ko.computed(() => {
      return this.items().length === 0;
    });
    this.values = ko.computed(_.bind(() => {
      return _.map(this.items(), (item) => {
        if (this.hasChanges) {
          item.hasErrors = false;
        }
        if (options.isNegativeAutoTarget) {
          return _.pick(item.toObject(), 'Criterion');
        } else {
          return _.pick(item.toObject(), 'Bid', 'Criterion');
        }
      });
    }, this));
    this.description = ko.computed(() => {
      return i18n.get('DSA_AutoTargets_Select_Description', {
        amount: this.adGroupBid(),
        currency: config.get('AccountCurrencyCode'),
      });
    });
    this.checkArgumentOperandFormat = (argumentOperand) => {
      let hasComma = false;
      let hasDoubleQuote = false;
      let resultArgumentOperand = argumentOperand;

      if (argumentOperand.includes(',')) {
        hasComma = true;
      }
      if (argumentOperand.includes('"')) {
        hasDoubleQuote = true;
      }
      if (hasDoubleQuote) {
        resultArgumentOperand = resultArgumentOperand.replaceAll('"', '""');
      }
      if (hasDoubleQuote || hasComma) {
        resultArgumentOperand = `"${resultArgumentOperand}"`;
      }
      return resultArgumentOperand;
    };
  }
}
